<template>
  <app-layout>
    <template v-slot:submenu>
      <sub-menu>
        <router-link :to="routeToSite" class="btn btn-outline-dark">
          <show-icon name="back" size="sm" class="align-middle"></show-icon>
          {{ t("models.site") }}
        </router-link>                
        <router-link :to="{ name: 'ListMeters', query: { site_id: site_uuid }}" class="btn btn-outline-dark">
          <show-icon name="back" size="sm" class="align-middle"></show-icon>
          <span class="d-none d-sm-inline">&nbsp;{{ t("models.meter", 2) }}</span>
        </router-link>        
        <router-link :to="{name: 'EditMeter', params: { id: meter.uuid } }" class="btn btn-outline-dark">
          <show-icon name="edit" size="sm" class="align-middle"></show-icon>
          <span class="d-none d-sm-inline">&nbsp;{{ t("edit") }}</span>
        </router-link>
        <button class="btn btn-outline-dark" @click="onGeoLocation">
          <show-icon name="gps_fixed" size="sm" class="align-middle"></show-icon>
          <span class="d-none d-sm-inline align-middle">&nbsp;{{ t("geo_location") }}</span>
        </button>  
        <button class="btn btn-danger" ref="deleteMeter" @click="onDeleteMeter">
          <show-icon name="delete" size="sm" class="align-middle"></show-icon>
          <span class="d-none d-sm-inline">&nbsp;{{ t('delete') }}</span>
        </button>        
      </sub-menu>
    </template>

    <template v-slot:default>
      <page-header icon="meter">
        <h4 class="lh-1 m-0">{{ meter.num }}</h4>
        <small>{{ site.name }}</small>
      </page-header>

      <div class="row">
        <div class="text-start">
          <p>{{ meter.description }}</p>
        </div>
      </div>      

      <hr class="md-2">

      <div class="row">
        <div class="col-6 col-sm-3 text-end">
          <b>{{ t("attributes.meter.type") }}</b>
        </div>
        <div class="col-6 col-sm-3 text-start">
          <p>{{ meter_type_name }}</p>
        </div>
        <template v-if="meter.lat">
          <div class="col-6 col-sm-3 text-end">
            <b>{{ t("attributes.long") }} / {{ t("attributes.lat") }}</b>
          </div>
          <div class="col-6 col-sm-3 text-start">
            <p>{{ meter.long }}, {{ meter.lat }}</p>
          </div>
        </template>
      </div>

      <div class="row">
        <template v-if="energySource">
          <div class="col-6 col-sm-3 text-end">
            <b>{{ t("attributes.energy_source") }}</b>
          </div>
          <div class="col-6 col-sm-3 text-start">
            <p>{{ energySource.name }}</p>
          </div>
        </template>        

        <template v-if="meter.unit_of_measure">
          <div class="col-6 col-sm-3 text-end">
            <b>{{ t("attributes.meter.unit_of_measure") }}</b>
          </div>
          <div class="col-6 col-sm-3 text-start">
            <p>{{ meter.unit_of_measure }}</p>
          </div>
        </template>        

        <template v-if="meter.serial_no">
          <div class="col-6 col-sm-3 text-end">
            <b>{{ t("attributes.meter.serial_no") }}</b>
          </div>
          <div class="col-6 col-sm-3 text-start">
            <p>{{ meter.serial_no }}</p>
          </div>
        </template>    

        <div class="col-6 col-sm-3 text-end">
          <b>{{ t("attributes.meter.multiplier") }}</b>
        </div>
        <div class="col-6 col-sm-3 text-start">
          <p>{{ meter.multiplier }}</p>
        </div>        
      </div>

      <hr class="md-2">

      <div class="bg-body rounded shadow-sm">
        <ul class="list-group">

          <li class="list-group-item d-flex">
              <div class="col">
                <router-link :to="{name: 'ListAssets', query: { site_id: site.uuid, meter_id: meter_uuid } }" class="btn btn-sm float-start">
                  <show-icon name="widgets" size="sm" class="align-middle"></show-icon>
                  {{ t("models.asset", nbAssets)}}
                </router-link>
                <span class="badge bg-primary rounded-pill">{{nbAssets}}</span>
              </div>
              <div class="col">
                <button class="float-end btn btn-sm" @click="onNewAsset">
                  <show-icon name="new" size="sm" class="align-middle"></show-icon>
                  <span class="d-none d-sm-inline align-middle">&nbsp;{{ t('new') }}</span>
                </button>
              </div>
          </li>

          <li class="list-group-item d-flex">
            <div class="col">
              <div class="btn btn-sm float-start">
                <show-icon name="location_on" size="sm" class="align-middle"></show-icon>&nbsp;{{ t("models.location", 1)}}
              </div>
            </div>
            <div class="col" v-if="meterLocation">
              <router-link :to="{name: 'ShowLocation', params: { id: meterLocation.uuid } }" class="btn btn-xs float-end text-end">
                {{ fullNameOfLocation }}
              </router-link>
            </div>
            <div class="col" v-else>
              <button class="float-end btn btn-sm" @click="onNewLocation">
                <show-icon name="new" size="sm"></show-icon>
                <span class="d-none d-sm-inline">&nbsp;{{ t('add') }}</span>
              </button>
            </div>
          </li>
          
          <NoteListItem :site-id="site_uuid" 
                        owner-type="Meter" 
                        :owner-id="meter.uuid">
          </NoteListItem>

          <ImageGalleryListItem owner_type="Meter" 
                                :owner_id="meter.uuid" 
                                :site_id="site_uuid">
          </ImageGalleryListItem>
        </ul>
      </div>

      <NewLocationPopup v-if="show_new_location_popup" 
                        :site-id="site_uuid" 
                        :meter-id="meter.uuid"                       
                        @locationUpdated="onlocationUpdated"
                        @closeNewLocationPopup="onCloseNewLocationPopup">
      </NewLocationPopup>

      <NewAssetPopup v-if="show_new_asset_popup" 
                     :site-id="site_uuid" 
                     :meter-id="meter.uuid"
                     @closeNewAssetPopup="onCloseNewAssetPopup">
      </NewAssetPopup>

    </template>
  </app-layout>
</template>

<script>
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { reactive, ref, computed } from 'vue';

import { routeToObject } from '@/common/url_path_helper';
import { locationFullName } from '@/common/location_helpers';
import { displayTypeNameOf } from '@/common/meter_helpers';

import NoteListItem from '@/components/NoteListItem.vue';
import ImageGalleryListItem from '@/components/ImageGalleryListItem.vue';
import NewAssetPopup from '@/views/assets/NewAssetPopup.vue';
import NewLocationPopup from '@/views/locations/NewLocationPopup.vue';

import { useUpdateGeoLocation } from '@/common/update_geo_location';

export default {
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const { t } = useI18n({ useScope: 'global' });
    //const { displayTypeNameOf } = meterHelpers();

    const meter_uuid = route.params.id;
    const meter = reactive(store.getters.getMeterByUUID(meter_uuid));
    
    const site_uuid = meter.site_uuid
    const site = store.getters.getSite(site_uuid);
    //const location = ref(meter.location_uuid ? store.getters.getLocationByUUID(meter.location_uuid) : null)
    const routeToSite = routeToObject('Site', meter.site_uuid);
    const show_new_asset_popup = ref(false);
    const show_new_location_popup = ref(false);

    const updateGeoLocation = useUpdateGeoLocation();
    const onGeoLocation = async function() {
      updateGeoLocation(meter, 'modifyMeter');
    }       

    const energySource = computed(function() {
      if (meter.energy_source_uuid) {
        return store.getters.getEnergySourceByUUID(meter.energy_source_uuid);
      } else {
        return null;
      }
    });

    const meter_type_name = computed(function() {
      return displayTypeNameOf(meter)
    });

    const allAssets = computed(function() {
      const allSiteAssets = store.getters.getAssetsBySiteUUID(site_uuid);
      console.log("Inside meters/Show.vue, allAssets(), allSiteAssets ==> ", allSiteAssets);
      return allSiteAssets.filter(asset => asset.meter_uuid === meter_uuid);
    });

    const nbAssets = computed(function() {
      console.log("Inside meters/Show.vue, nbAssets(), allAssets ==> ", allAssets);
      return allAssets.value.length;
    });

    const meterLocation = computed(function() {
      return meter.location_uuid ? store.getters.getLocationByUUID(meter.location_uuid) : null
    })

    const onNewAsset = function() {
      show_new_asset_popup.value = true
    }

    const onCloseNewAssetPopup = function() {
      show_new_asset_popup.value= false
    }

    const onNewLocation = function() {
      show_new_location_popup.value = true
    }    

    const onCloseNewLocationPopup = function() {
      show_new_location_popup.value = false
    }

    const onlocationUpdated = function(location_uuid) {
      console.log("Inside assets/Show.vue, onlocationUpdated(), location_uuid ==> ", location_uuid);
      if (location_uuid) {
        meter.location_uuid = location_uuid;
        store.dispatch("modifyMeter", meter);
        show_new_location_popup.value = false;
      }
    }    

    const fullNameOfLocation = computed(function() {
      const location = meterLocation.value;
      if (location) {
        return locationFullName(location).reduce(function(str, n) {
          return (str.length > 0) ? (str + " :: " + n) : n
        }, "");
      } else {
        return null;
      }      
    });

    const onDeleteMeter = function() {
      if (confirm(t('are_you_sure'))) {
        store.dispatch("deleteMeter", meter_uuid);
        router.push({ name: "ListMeters", query: { site_id: site_uuid } });
      }
    }

    return {
      meter_uuid,
      meter,
      meter_type_name,
      site,
      site_uuid,
      //location,
      routeToSite,
      energySource,
      onGeoLocation,
      allAssets,
      nbAssets,
      onNewAsset,
      onCloseNewAssetPopup,
      onNewLocation,
      onCloseNewLocationPopup,
      show_new_asset_popup,
      show_new_location_popup,
      onlocationUpdated,
      meterLocation,
      fullNameOfLocation,
      onDeleteMeter,
      t
    }

  },
  components: {
    NoteListItem,
    ImageGalleryListItem,
    NewAssetPopup,
    NewLocationPopup
  }
}
</script>